import { render } from "./IconSpecify.vue?vue&type=template&id=3c4f6ef6&scoped=true"
import script from "./IconSpecify.vue?vue&type=script&lang=js"
export * from "./IconSpecify.vue?vue&type=script&lang=js"

import "./IconSpecify.vue?vue&type=style&index=0&id=3c4f6ef6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4f6ef6"]])

export default __exports__